module.exports = __webpack_public_path__ + "static/media/fish.7910c16f.svg";